module.exports = __webpack_public_path__ + "static/abdelghani-tie-5ea4de549e2e73930c4008d11a1214cc.jpg";